export default "__VITE_ASSET__BZk6dsyv__"